import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

// reducer import
import postalReducer from './postalReducer';
import cateringReducer from './cateringReducer';
import trafficReducer from './trafficReducer';
import greeningReducer from './greeningReducer';
import cleanReducer from './cleanReducer';
import foodReducer from './foodReducer';
import dormitoryReducer from './dormitoryReducer';
import environmentReducer from './environmentReducer';
import repairReducer from './repairReducer';
import worshipReducer from './worshipReducer';
import laborReducer from './laborReducer';
import officeReducer from './officeReducer';


// ==============================|| COMBINE REDUCER ||============================== //
const serviceReducer = combineReducers({
  // catering: persistReducer(
  //   {
  //     key: 'catering',
  //     storage,
  //     keyPrefix: 'sim-'
  //   },
  //   cateringReducer
  // ),
  catering: cateringReducer,
  food: foodReducer,
  postal: postalReducer,
  traffic: trafficReducer,
  clean: cleanReducer,
  dormitory: dormitoryReducer,
  greening: greeningReducer,
  environment: environmentReducer,
  repair: repairReducer,
  worship: worshipReducer,
  labor: laborReducer,
  office: officeReducer,
});

export default serviceReducer;
